import React, { Component } from 'react';
import { HeaderMenu as HeaderMenuUDL } from './component';
import { HeaderMenu as HeaderMenuLegacy } from './component.legacy';
import { propTypes, defaultProps } from './types';
import PropTypes from 'prop-types';

export class HeaderMenu extends Component {
  render() {
    const { renderAsLegacy, ...rest } = this.props;
    if (renderAsLegacy) {
      return <HeaderMenuLegacy {...rest} />;
    }
    return <HeaderMenuUDL {...rest} />;
  }
}

HeaderMenu.propTypes = {
  renderAsLegacy: PropTypes.bool,
  ...propTypes,
};

HeaderMenu.defaultProps = {
  renderAsLegacy: true,
  ...defaultProps,
};
